import { initNav } from '../components/nav';

initNav();

const emailInput = document.getElementById('email') as HTMLInputElement | null;
const passwordInput = document.getElementById('password') as HTMLInputElement | null;
const alertBox = document.getElementById('auth-alert') as HTMLElement | null;
const authForm = document.getElementById('auth-form') as HTMLFormElement | null;
const submitBtn = document.getElementById('auth-submit-btn') as HTMLButtonElement | null;

function showAlert(msg: string, isError = true): void {
  if (!alertBox) return;
  alertBox.textContent = msg;
  alertBox.className = `auth-alert ${isError ? 'error' : 'success'}`;
}

function clearAlert(): void {
  if (!alertBox) return;
  alertBox.textContent = '';
  alertBox.className = 'auth-alert';
}

function setBtnLoading(loading: boolean): void {
  if (!submitBtn) return;
  submitBtn.disabled = loading;
  submitBtn.style.opacity = loading ? '0.7' : '';
  const textSpan = submitBtn.querySelector('span');
  if (textSpan) {
    textSpan.textContent = loading ? 'Verifying...' : 'Sign In';
  }
}

authForm?.addEventListener('submit', async (e) => {
  e.preventDefault();
  clearAlert();

  const email = emailInput?.value.trim() || '';
  const password = passwordInput?.value || '';

  if (!email || !password) {
    showAlert('Please enter your student email and password.');
    return;
  }

  setBtnLoading(true);

  try {
    const res = await fetch('/api/auth/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
      showAlert(data.error || 'Invalid credentials or unauthorized student.');
      setBtnLoading(false);
      return;
    }

    showAlert('Access authorized! Entering the arena...', false);

    // Go has already set the HttpOnly chessmechanic_session cookie
    setTimeout(() => {
      window.location.href = '/puzzle';
    }, 450);
  } catch (err) {
    showAlert('Unable to reach authentication server.');
    setBtnLoading(false);
  }
});